import React, { lazy, Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Bugraphs } from "../components/Builders/Bugrafx/Bugraphs";
import { getDataUser, setTemporalUsers } from "../libs/redux/slices/authSlice/authSlice";
import { useGetGraphsQuery } from "../libs/redux/slices/Graficsx/graficsxApiSlice";
import { useGetUserTemporalQuery, useGetDashboardQuery, useGetTurnsTodayByUserQuery } from "../libs/redux/slices/authSlice/authApiSlice";
import { TableLoader, BoxStatus, ShiftBanner, Box } from "codekit";

function DashboardHome() {
  const dispatch = useDispatch();
  const { USRIDXXX, CARIDXXX } = useSelector(getDataUser);
  const { data: graphs } = useGetGraphsQuery({ USRIDXXX, CARIDXXX });
  const { data: turnsByUser } = useGetTurnsTodayByUserQuery({ USRIDXXX });
  const { data: temporalUsers, isSuccess } = useGetUserTemporalQuery({ USRIDXXX });
  const [banner, setBanner] = React.useState(null);
  const { data: dataGraphics, isSuccess: isSuccessGraphics } = useGetDashboardQuery();
  const graphics = ["TASKGRAF", "CARXTEAM", "INGEPROP", "OPESNFAC"]
  const graphicsTurn = ["NOTITURN"];

  const toDateAt = (dateStr, timeStr) => new Date(`${dateStr}T${timeStr}`);

  const fmtHour = (d) =>
    d.toLocaleTimeString('es-CO', { hour: 'numeric', minute: '2-digit', hour12: true });


  //Hook para el seteo de los usuarios reemplazo
  useEffect(() => {
    if (isSuccess) {
      const { data = [] } = temporalUsers;
      dispatch(setTemporalUsers(data));
    }
  }, [isSuccess, temporalUsers, dispatch]);

  React.useEffect(() => {
    const compute = () => {
      const dayData = turnsByUser?.data;
      const turns = dayData?.TURNSXXX ?? [];

      if (!Array.isArray(turns) || turns.length === 0) {
        setBanner({ visible: false, variant: 'start', primary: '', secondary: '' });
        return;
      }

      const dateStr = dayData.DATEXXXX;

      const ranges = turns
        .flatMap(t => (t.RANGESXX ?? []).map(r => ({
          start: toDateAt(dateStr, r.STARTXXX),
          end:   toDateAt(dateStr, r.ENDXXXXX),
        })))
        .sort((a, b) => a.start - b.start);

      const now = new Date();

      const current = ranges.find(r => now >= r.start && now < r.end);
      if (current) {
        setBanner({
          visible: true,
          variant: 'end',
          primary: `Tu turno termina a las ${fmtHour(current.end)}`,
          secondary: 'Recuerda finalizar tu turno en la opción Cerrar Turno',
        });
        return;
      }

      const next = ranges.find(r => now < r.start);
      if (next) {
        setBanner({
          visible: true,
          variant: 'start',
          primary: `Tu turno inicia a las ${fmtHour(next.start)}`,
          secondary: `Hoy (${dayData.DAYXXXXX}). Recuerda finalizar tu turno en la opción Cerrar Turno`,
        });
        return;
      }

      setBanner({ visible: false, variant: 'start', primary: '', secondary: '' });
    };

    compute();
    const id = setInterval(compute, 5 * 60 * 1000); // 5 minutos
    return () => clearInterval(id);
  }, [turnsByUser]);

  if (!isSuccessGraphics || !graphs) {
    return <BoxStatus variant="loading" text="Cargando información..." />;
  }
  const hasBugraphs = dataGraphics.data.some(
    (item) => graphics.includes(item.GRACOMXX)
  );
  const hasTurns = dataGraphics.data.some(
    (item) => graphicsTurn.includes(item.GRACOMXX)
  );
  const otherComponents = dataGraphics.data.filter(
    (item) => !graphics.includes(item.GRACOMXX)
  );

  return (
    <>
      {hasTurns && banner?.visible && (
        <Box spacing={5}>
          <ShiftBanner
            variant={banner.variant}
            srcBgImage="/images/cima-icon.png"
            primaryText={banner.primary}
            secondaryText={banner.secondary}
            alignment="left"
            imageRotation={-10}
            imageX={95}
          />
        </Box>
      )}
      {hasBugraphs && <Bugraphs graphs={graphs.data} />}
      {otherComponents.map((CIMS0036, index) => {
        const CurrentGraphic = lazy(() =>
          import(`../components/${CIMS0036.GRACOMXX}`).catch((error) => {
            return { default: () => null };
          })
        );

        return (
          <Suspense fallback={<TableLoader />} key={index}>
            <CurrentGraphic />
          </Suspense>
        );
      })}
    </>
  );
}

export default DashboardHome;
